import { Component, Inject, OnInit } from '@angular/core';
import {
  FormBuilder as NgFormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IOrder } from 'src/modules/order/interfaces/order';

@Component({
    selector: 'order-notes-edit',
    templateUrl: 'component.html',
    styleUrls: [
        '../../../order/components/order-list/component.scss',
        'component.scss',
    ],
    standalone: false
})
export class OrderNotesEdit implements OnInit {
  public form: FormGroup;

  public readonly Order: IOrder;

  public settings = {
    title: 'Edit Order',
    refund: false,
    icon: 'save',
    buttonText: 'Save',
  };

  public constructor(
    private readonly FormBuilder: NgFormBuilder,
    protected DialogRef: MatDialogRef<OrderNotesEdit>,
    @Inject(MAT_DIALOG_DATA)
    private readonly config: { Order: IOrder; refund?: boolean }
  ) {
    this.Order = config.Order;

    if (config.refund) {
      this.settings = {
        title: 'Refund Order',
        refund: true,
        icon: 'remove_shopping_cart',
        buttonText: 'Refund',
      };
    }
  }

  ngOnInit() {
    this.form = this.FormBuilder.group({
      notes: [null, Validators.required],
    });

    !this.config.refund &&
      this.form.controls['notes'].patchValue(this.Order['notes']);
  }

  onSubmit() {
    const { order_id } = this.Order;
    this.form.disable();

    let { notes } = this.form.getRawValue();
    const { notes: orderNotes } = this.Order;

    !!this.config.refund && orderNotes && (notes = `${orderNotes} \n${notes}`);

    const order = {
      notes,
      order_id,
    };

    this.DialogRef.close(order);
  }
}
